export enum ActionTypes {
    save = 'save',
    saveCreate = 'saveCreate',
    saveEdit = 'saveEdit'
}